import 'antd/dist/reset.css'
import React from 'react'
import UserProvider from './context/userContext.js'
import StoreProvider from './context/storeContext'
import { BrowserRouter as Router } from 'react-router-dom'
import { AuthorizedContent, UnauthenticatedContent } from './flows'
import { NavigationProvider } from './context/navigationContext'
import { useIsAuthenticated } from '@azure/msal-react'
import { useScreenSizeClass } from './utils/mediaQuery'
import { ConfigProvider } from 'antd'
import './utils/networkStatusUtils.js'

function App() {
  const userAuthenticated = useIsAuthenticated()
  const isLoggedIn = localStorage.getItem('authenticated') === 'true'
  const loginType = localStorage.getItem('loginType')

  if (isLoggedIn && (useIsAuthenticated || loginType === 'cognito')) {
    return (
      <StoreProvider>
        <AuthorizedContent />
      </StoreProvider>
    )
  } else if (!isLoggedIn || !userAuthenticated) {
    return <UnauthenticatedContent />
  }
}

export default function Root() {
  const screenSizeClass = useScreenSizeClass()
  return (
    <ConfigProvider>
      <Router>
        <UserProvider>
          <NavigationProvider>
            <div className={`app ${screenSizeClass}`}>
              <App />
            </div>
          </NavigationProvider>
        </UserProvider>
      </Router>
    </ConfigProvider>
  )
}